import { IGetState, TBoardId } from '../../../types/types';
import { Dispatch, ThunkAction } from '../../../types/actions';
import { boardSetUserMeta } from './boardSetUserMeta';

export const boardSetHideCardAgeingSnackbar = (
    boardId: TBoardId
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        return dispatch(boardSetUserMeta(boardId, { isHideCardAgeingSnackbar: true }));
    };
    return action;
}
